module.exports = __webpack_public_path__ + "img/_03_93bd7b8ba.png";